// @flow

import type {Account} from 'docs/data';
import type {AccountRequestModel} from 'docs/types';
import {
  createMockMerchant,
  transformAccountXRay,
  transformAlternativeMerchant,
  transformCountry,
  transformLocale,
  transformMerchant,
  transformMerchantKeys,
  transformUser,
} from 'docs/server/transformers';

type AccountResponse = Account | AccountRequestModel;

export const transformAccount = (model: AccountResponse): Account => {
  // TODO(adreyfus): Once we are off site-srv we can remove this transformation step
  if (!model.all_countries) {
    return model;
  }

  const cookieEnforcementMode =
    model.cookie_enforcement_mode === 'open' ? 'open' : 'restricted';

  const cookieBannerShowRejectAll =
    model.cookie_banner_show_reject_all === true;

  // TODO (nkohari): We should remove dashboardUrl from the Account type and just use
  // the hosts map. This pre-dates the host map, but it's now redundant.
  const dashboardUrl = model.hosts['dashboard.stripe.com'];

  return {
    availableCountries: model.all_countries.map(transformCountry),
    availableLocales: model.all_locales.map(transformLocale),
    availableMerchants: model.all_merchants.map(transformAlternativeMerchant),
    latestApiVersion: model.latest_api_version,
    cookieBannerShowRejectAll,
    cookieEnforcementMode,
    country: transformCountry(model.country),
    dashboardUrl,
    flags: model.flags,
    hosts: model.hosts,
    keys: transformMerchantKeys(model.keys),
    locale: transformLocale(model.locale),
    merchant: model.merchant
      ? transformMerchant(model.merchant, model.api_version)
      : createMockMerchant(model),
    treatments: model.treatments || {docs_sidebar_content: null},
    user: model.user ? transformUser(model.user) : null,
    xray: model.xray ? transformAccountXRay(model.xray) : null,
  };
};
